var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14062 6.04688C5.14062 5.08038 5.92413 4.29688 6.89062 4.29688C7.85712 4.29688 8.64062 5.08038 8.64062 6.04688C8.64062 7.01337 7.85712 7.79688 6.89062 7.79688C5.92413 7.79688 5.14062 7.01337 5.14062 6.04688ZM6.89062 3.29688C5.37184 3.29688 4.14062 4.52809 4.14062 6.04688C4.14062 7.56566 5.37184 8.79688 6.89062 8.79688C8.40941 8.79688 9.64062 7.56566 9.64062 6.04688C9.64062 4.52809 8.40941 3.29688 6.89062 3.29688ZM4.92188 10.0469C4.19253 10.0469 3.49306 10.3366 2.97733 10.8523C2.46161 11.3681 2.17188 12.0675 2.17188 12.7969V13.9219C2.17188 14.198 2.39573 14.4219 2.67188 14.4219C2.94802 14.4219 3.17188 14.198 3.17188 13.9219V12.7969C3.17188 12.3327 3.35625 11.8876 3.68444 11.5594C4.01263 11.2312 4.45775 11.0469 4.92188 11.0469H8.85938C9.3235 11.0469 9.76862 11.2312 10.0968 11.5594C10.425 11.8876 10.6094 12.3327 10.6094 12.7969V13.9219C10.6094 14.198 10.8332 14.4219 11.1094 14.4219C11.3855 14.4219 11.6094 14.198 11.6094 13.9219V12.7969C11.6094 12.0675 11.3196 11.3681 10.8039 10.8523C10.2882 10.3366 9.58872 10.0469 8.85938 10.0469H4.92188Z",
    fill: "#C1C5D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5625V6.1875",
    stroke: "#C1C5D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 7.875H11.8125",
    stroke: "#C1C5D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoining);
export default __webpack_public_path__ + "static/media/joining.6ee577953f2aaeb7a640f2f5d47026d0.svg";
export { ForwardRef as ReactComponent };